<template>
  <div>
    <Table :columns="columns" :rows="this.projectData.files.map((i) => ({ name: i }))" :pagination="false" tableName="projectFiles" />
  </div>
</template>

<script>
import axios from 'axios';

import Table from '../../../../common/table';
import { AuthStorageMixin } from '../../../../../../mixins';

export default {
  name: 'Files',
  components: { Table },
  mixins: [AuthStorageMixin],
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
  },
  async created() {
    console.log(this.projectData, 'projectData');
  },
  methods: {
    downloadFile(name) {
      const auth = this.authStorageService.getAuth();
      window.open(`${axios.defaults.baseURL}/api/v1/one/project/file?name=${name}&authorization=${auth.access_token_link}`, '_blank');
    },
  },
  data: function () {
    return {
      columns: [
        { key: '1', field: 'name', title: this.$translate('name'), align: 'left' },
        {
          field: 'actions',
          key: 'actions',
          title: '',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="action-block">
                <div class="copy-button" on-click={() => this.downloadFile(row.name)}>
                  {this.$translate('Download')}
                </div>
              </div>
            );
          },
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.case-table {
  tr {
    cursor: pointer;
  }
}

.badge {
  padding: 0.25em 0.4em !important;
}

.table-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 300;
  margin-bottom: 20px;
  margin-top: 10px;
}

.action-block {
  display: flex;
  flex-direction: row;
  align-items: center;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  max-width: 200px;
}
</style>
